var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",staticClass:"fform",attrs:{"method":"post","novalidate":""},on:{"submit":_vm.onSubmit,"reset":_vm.onReset}},[_vm._t("default",null,null,_vm.slotProps)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }